var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdvancedSearch',{directives:[{name:"show",rawName:"v-show",value:(_vm.functionStatus == '高级搜索'),expression:"functionStatus == '高级搜索'"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }